<template>
    <Breadcrumbs
        main="Liste des sondages"
        mains="Liste des sondages"
        title="Echanges"
    />
    <div class="container-fluid">
        <div class="row">
            <SurveyList />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const SurveyList = defineAsyncComponent(
    () => import('@/components/theme/survey/SurveyList.vue'),
);
</script>